import * as React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useXyqarAuth } from '@xyqar/shared-auth';
import { apiPost } from '../lib/api';
import { PageTitle, Card, Btn } from '../components/ui-kit';
import { Shield } from 'lucide-react';

export default function ContractSign() {
  const { id } = useParams();
  const nav = useNavigate();
  const { getToken } = useXyqarAuth();
  const [otpEmail, setOtpEmail] = React.useState('');
  const [otpSms,   setOtpSms]   = React.useState('');
  const [submitting, setSubmitting] = React.useState(false);
  const [err, setErr] = React.useState<string | null>(null);

  const inp = 'w-full rounded-md bg-white/5 border border-white/10 px-4 py-3 text-center text-lg tracking-[0.4em] text-white placeholder-white/20 focus:outline-none focus:border-white/40 font-mono';

  const sign = async () => {
    setSubmitting(true);
    setErr(null);
    try {
      const tok = await getToken().catch(() => '');
      await apiPost(`/api/v1/exec/contracts/${id}/sign`, {
        otp_email: otpEmail,
        otp_sms:   otpSms,
      }, tok);
      nav(`/contracts/${id}/review`);
    } catch (e: any) {
      setErr(e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <PageTitle kicker={`Contract · ${id}`} title="Signature" />

      <Card>
        <div className="flex items-center gap-3 mb-6 text-green-400">
          <Shield className="h-4 w-4" />
          <span className="text-[10px] uppercase tracking-[0.2em] font-mono">PAdES · SHA-256 · OTP dual channel</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <Field label="Email OTP (6 digits)">
            <input className={inp} maxLength={6} value={otpEmail}
              onChange={(e) => setOtpEmail(e.target.value.replace(/\D/g, ''))} />
          </Field>
          <Field label="SMS OTP (6 digits)">
            <input className={inp} maxLength={6} value={otpSms}
              onChange={(e) => setOtpSms(e.target.value.replace(/\D/g, ''))} />
          </Field>
        </div>

        {err && <p className="text-red-300 text-sm mt-4">{err}</p>}

        <p className="text-xs text-white/40 mt-6">
          By signing, this contract is sealed with PAdES + SHA-256, the PDF is emailed to all parties,
          and tenant Docker/K8s provisioning is triggered.
        </p>

        <div className="flex justify-end mt-6">
          <Btn primary onClick={sign} disabled={submitting || otpEmail.length !== 6 || otpSms.length !== 6}>
            {submitting ? 'Sealing…' : 'Sign &amp; seal'}
          </Btn>
        </div>
      </Card>
    </div>
  );
}

function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label className="flex flex-col gap-2">
      <span className="text-xs uppercase tracking-wider text-white/60">{label}</span>
      {children}
    </label>
  );
}
